const PhoneIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18.1182 14.702L14 15.5C11.2183 14.1038 9.50001 12.5 8.50001 10L9.26996 5.8699L7.81453 2H4.06361C2.93606 2 2.04815 2.93178 2.21655 4.04668C2.63696 6.83 3.87654 11.8765 7.50001 15.5C11.3052 19.3052 16.7857 20.9564 19.802 21.6127C20.9668 21.8662 22 20.9575 22 19.7655V16.1812L18.1182 14.702Z" stroke="#272727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
    
export default PhoneIcon;
    